import React, {useEffect, useState} from "react";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import moment from "jalali-moment";
import {useDebounce} from "@uidotdev/usehooks";
import {TransactionService} from "../../serverService/transactionService/TransactionService";
import {useNavigate} from "react-router-dom";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import {
    convertCurrencyFormat,
    convertUniversalDateTimeToPersianDateTime, RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator,
    RaikoChipTypes, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoCustomSimpleChip, RaikoDatePicker,
    RaikoGridOneColumn, RaikoGridThreeColumn, RaikoLabel, RaikoMobileInputOutlined, RaikoSectionContainer,
    showErrorMessage,
    showWarningMessage, RaikoTableTitleContainer, RaikoCustomTable
} from "@moeindal/base-raiko-panel-components";

export const TransactionsList = ({gateWayId = -1}) => {

    let page = 0
    const size = 20

    const service = new TransactionService()

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [transactionList, setTransactionList] = useState([]);

    const [startDateFilter, setStartDateFilter] = useState("");
    const [endDateFilter, setEndDateFilter] = useState("");
    const [phoneNumberFilter, setPhoneNumberFilter] = useState("");
    const [summationOfAmount, setSummationOfAmount] = useState(0)

    const _startDateFilter = useDebounce(startDateFilter, 500)
    const _endDateFilter = useDebounce(endDateFilter, 500)
    const _phoneNumberFilter = useDebounce(phoneNumberFilter, 500)


    const [statusFilter, setStatusFilter] = useState(paymentStatus.ALL.id);

    const [numberOfItems, setNumberOfItems] = useState(0);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDataFromServer()
        }

    }, [
        _startDateFilter,
        _endDateFilter,
        _phoneNumberFilter
    ]);

    function getDataFromServer(status = statusFilter) {
        setIsLoading(true)

        service.getTransactionListData(
            page,
            size,
            _startDateFilter,
            _endDateFilter,
            _phoneNumberFilter,
            status,
            gateWayId
        ).then(response => {

            setPageCount(response.totalPage)

            setTransactionList([])
            setNumberOfItems(response.numberOfItems)

            response.data.map((item, index) => {
                setTransactionList(prevState => [
                    ...prevState,
                    prepareTransactionListRow(
                        item.id,
                        (page * size) + index + 1,
                        item.payerFirstName,
                        item.payerLastName,
                        item.payerPhoneNumber,
                        item.payerNationalCode,
                        item.createdAtDate,
                        item.status,
                        item.amount,
                        item.createdAtPersianTime,
                        item.paymentGatewayTitle,
                    )
                ])
            })
            setSummationOfAmount(response.summationOfAmount/10)

            setIsLoading(false)
        }).catch(reason => {

            showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت لیست تراکنشات."))
            setIsLoading(false)
        })
    }

    function prepareTransactionListRow(
        id,
        number,
        payerFirstName,
        payerLastName,
        payerPhoneNumber,
        payerNationalCode,
        createdAtDate,
        status,
        amount,
        hour,
        paymentGatewayTitle,
    ) {

        const m = moment(hour, "hh:mm:ss")
        m.local('fa')


        return {
            id: id,
            number,
            payerFirstName: payerFirstName ? payerFirstName : "-",
            payerLastName: payerLastName ? payerLastName : "-",
            payerPhoneNumber: payerPhoneNumber ? payerPhoneNumber : "-",
            amount: convertCurrencyFormat(amount/10),
            payerNationalCode: payerNationalCode ? payerNationalCode : "-",
            createdAtDate: convertUniversalDateTimeToPersianDateTime(createdAtDate),
            createdTime: `${m.format('HH:mm:ss')}`,
            paymentGatewayTitle: paymentGatewayTitle,
            status: status === paymentStatus.SUCCESS.id ?
                <RaikoCustomSimpleChip
                    title={paymentStatus.SUCCESS.name}
                    type={RaikoChipTypes.success}/> :
                status === paymentStatus.UN_SUCCESS.id ?
                    <RaikoCustomSimpleChip
                        title={paymentStatus.UN_SUCCESS.name}
                        type={RaikoChipTypes.error}/> :
                    <RaikoCustomSimpleChip
                        title={paymentStatus.AWAITING_FOR_PAYMENT.name}
                        type={RaikoChipTypes.warning}/>

        }
    }


    function checkFilters() {
        let state = false
        let message = ""

        if (startDateFilter.length > 0 && startDateFilter.length !== 10)
            message = "لطفا تاریخ شروع بازه را به درستی وارد نمایید!"
        else if (endDateFilter.length > 0 && endDateFilter.length !== 10)
            message = "لطفا تاریخ پایان بازه را به درستی وارد نمایید!"
        else
            state = true

        showWarningMessage(message)

        return state
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    const navigate = useNavigate()

    function showTransactionDetail(id) {
        navigate(RouteHelper.TransactionDetail.globalUrl.replace(":id", id))
    }

    return (
        <>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    {
                        gateWayId === -1 &&
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator("تراکنشات", ""),
                            raikoBreadCrumbItemGenerator("سابقه تراکنشات", ""),
                        ]}/>
                    }

                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoLabel text={"فیلتر ها"}/>
                            <RaikoCustomSelect
                                labelText={"وضعیت"}
                                setValue={setStatusFilter}
                                onChange={e => {
                                    getDataFromServer(e.target.value)
                                }}
                                items={[
                                    raikoCustomSelectItemGenerator(paymentStatus.ALL.id, paymentStatus.ALL.name),
                                    raikoCustomSelectItemGenerator(paymentStatus.SUCCESS.id, paymentStatus.SUCCESS.name),
                                    raikoCustomSelectItemGenerator(paymentStatus.UN_SUCCESS.id, paymentStatus.UN_SUCCESS.name),
                                    raikoCustomSelectItemGenerator(paymentStatus.AWAITING_FOR_PAYMENT.id, paymentStatus.AWAITING_FOR_PAYMENT.name),
                                ]}
                                value={statusFilter}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جستجو"}
                            subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                        >
                            <RaikoGridThreeColumn>
                                <RaikoMobileInputOutlined
                                    labelText={"شماره همراه"}
                                    setValue={setPhoneNumberFilter}
                                    value={phoneNumberFilter}/>
                                <RaikoDatePicker
                                    label={"شروع بازه"}
                                    setDate={setStartDateFilter}
                                    date={startDateFilter}/>
                                <RaikoDatePicker
                                    label={"پایان بازه"}
                                    setDate={setEndDateFilter}
                                    date={endDateFilter}/>
                            </RaikoGridThreeColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"تراکنش ها"}
                                amount={numberOfItems}
                            />
                            <RaikoCustomTable
                                isLoading={isLoading}
                                data={transactionList}
                                header={transactionHeader}
                                handlePaginationChange={handleChangePagination}
                                pageCount={pageCount}
                                rowClicked={showTransactionDetail}
                                summationOfAmount={summationOfAmount}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}


export const paymentStatus = {
    ALL: {
        id: "ALL",
        name: "همه"
    }, SUCCESS: {
        id: "SUCCESS",
        name: "موفق"
    }, UN_SUCCESS: {
        id: "UN_SUCCESS",
        name: "ناموفق"
    }, AWAITING_FOR_PAYMENT: {
        id: "AWAITING_FOR_PAYMENT",
        name: "در حال انجام"
    },
}

const transactionHeader = [
    {
        id: "number",
        label: "#"
    }, {
        id: "payerFirstName",
        label: "نام"
    }, {
        id: "payerLastName",
        label: "نام خانوادگی"
    }, {
        id: "payerPhoneNumber",
        label: "شماره همراه"
    }, {
        id: "payerNationalCode",
        label: "کدملی"
    }, {
        id: "amount",
        label: "مبلغ (تومان)"
    }, {
        id: "createdAtDate",
        label: "تاریخ"
    }, {
        id: "createdTime",
        label: "زمان"
    }, {
        id: "paymentGatewayTitle",
        label: "درگاه"
    }, {
        id: "status",
        label: "وضعیت"
    },
]